import { ConversationsService, RunsService } from "@/generated";
import type { BulkRunActionRequest, RunFilters } from "@/generated";

export type HistoryDeletionResult = {
  succeeded: number;
  failed: number;
};

export type RunHistoryDeletion = BulkRunActionRequest;
export type { RunFilters };

export type ResourceHistoryDeletion = {
  resource_id: string;
  resource_type: "workflow" | "assistant";
};

export const deleteRunHistory = (groupId: string, body: RunHistoryDeletion) =>
  RunsService.bulkDelete({ path: { group_id: groupId }, body });

/** Lets a caller deleting a resource *and* its history report which of the two
 * writes failed, and leave the resource alone when it was the history. */
export class HistoryDeletionError extends Error {
  constructor(readonly reason: unknown) {
    super("Failed to delete usage history");
    this.name = "HistoryDeletionError";
  }
}

export const deleteResourceUsageHistory = async (
  groupId: string,
  body: ResourceHistoryDeletion
): Promise<{ data: HistoryDeletionResult }> => {
  if (body.resource_type === "workflow") {
    const result = await RunsService.bulkDelete({
      path: { group_id: groupId },
      body: { filters: { workflow_id: body.resource_id } },
    });
    return { data: result.data };
  }
  const result = await ConversationsService.bulkDeleteConversations({
    path: { group_id: groupId },
    body: { assistant_id: body.resource_id },
  });
  return { data: result.data };
};
